<form *ngLet="selectCatalogItem$ | async as selectCatalogItems" [formGroup]="form" class="form">
  <ng-container *ngLet="itemFields$ | async as fields">
    <div class="row incorrect-data">
      <button class="btn-empty detail-btn" type="button" (click)="isDetailedShow = !isDetailedShow">
        <svg [icon]="icons.Info" class="svg24 primary-color mr4" />
        <span class="link-6">{{ 'DATA.SHARED.APPEALS.DATA_ABOUT_ITEM_OF_DATASET' | translate }}</span>
      </button>
      <mat-form-field *ngIf="!isImpaired" appearance="outline" class="disabled appeal-input">
        <mat-label>{{ 'OTHER.DATASET_NAME' | translate }}</mat-label>
        <input class="catalog-name" matInput formControlName="nameCatalog" [ngModel]="(selectCatalog$ | async)?.catalogName" />
      </mat-form-field>

      <app-impaired-input
        *ngIf="isImpaired"
        placeholder="{{ 'OTHER.WRITE' | translate }} {{ ('OTHER.DATASET_NAME' | translate)?.toLowerCase() }}"
        header="{{ 'OTHER.DATASET_NAME' | translate }}"
        [control]="$any(form.controls.nameCatalog)"
        [defaultValue]="(selectCatalog$ | async)?.catalogName ?? ''"
      ></app-impaired-input>

      <ng-container *ngLet="problemFieldObserver$ | async">
        <mat-form-field *ngIf="!isImpaired" appearance="outline" class="appeal-input select mat-sec">
          <mat-label>{{ 'DATA.SHARED.APPEALS.ISSUE' | translate }}</mat-label>
          <mat-select [disableOptionCentering]="true" required formControlName="problem" panelClass="problem-select">
            <mat-option [value]="true">{{ 'DATA.SHARED.APPEALS.INCORRECT_VALUES_ATTRIBUTES_ITEM_DATASET' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'DATA.SHARED.APPEALS.PRESENCE_NON-EXISTENT_ITEM_DATASET' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="select-container" *ngIf="isImpaired">
          <span  [class.error]="$any(form.controls.problem).errors && $any(form.controls.problem).touched" class="h4-impaired">{{ 'DATA.SHARED.APPEALS.ISSUE' | translate }} ({{ ('VERSION_VISUALLY_IMPAIRED.REQUIRED' | translate).toLowerCase() }})</span>
          <div #selectContainer class="select-container-icon">
          <mat-select
            [disableOptionCentering]="true"
            required
            #select
            formControlName="problem"
            class="body1-impaired impaired"
            panelClass="problem-select"
            placeholder="{{ 'DATA.SHARED.APPEALS.ISSUE' | translate }}"
            [class.error]="$any(form.controls.problem).errors && $any(form.controls.problem).touched"
          >
            <mat-option [value]="true">{{ 'DATA.SHARED.APPEALS.INCORRECT_VALUES_ATTRIBUTES_ITEM_DATASET' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'DATA.SHARED.APPEALS.PRESENCE_NON-EXISTENT_ITEM_DATASET' | translate }}</mat-option>
          </mat-select>
            <app-impaired-icon
              *ngIf="selectContainer.offsetWidth > 0"
              [style.left]="selectContainer.offsetWidth - 24 | px"
              [iconName]="icons.BigTriangleDown"
              [classSize]="'big-impaired'"
              class="icon"
              (clickOnIcon)="select.open()"
            ></app-impaired-icon>
          </div>
        </div>
      </ng-container>
      <mat-form-field *ngIf="!isImpaired" appearance="outline" class="disabled appeal-input">
        <mat-label>{{ 'DATA.SHARED.APPEALS.ROW_NO' | translate }}</mat-label>
        <input matInput formControlName="rowNumber" [ngModel]="selectCatalogItems?.number ?? 1" />
      </mat-form-field>

      <app-impaired-input
        *ngIf="isImpaired"
        placeholder="{{ 'OTHER.WRITE' | translate }} {{ ('DATA.SHARED.APPEALS.ROW_NO' | translate)?.toLowerCase() }}"
        header="{{ 'DATA.SHARED.APPEALS.ROW_NO' | translate }}"
        [control]="$any(form.controls.rowNumber)"
        [defaultValue]="selectCatalogItems?.number ?? 1"
      ></app-impaired-input>

      <mat-form-field *ngIf="!isImpaired" appearance="outline" class="appeal-input flex">
        <mat-label>{{ 'OTHER.COMMENTS' | translate }}</mat-label>
        <textarea class="comment" matInput formControlName="comment"></textarea>
      </mat-form-field>

      <app-impaired-input
        *ngIf="isImpaired"
        placeholder="{{ 'OTHER.WRITE' | translate }} {{ ('OTHER.COMMENTS' | translate)?.toLowerCase() }}"
        header="{{ 'OTHER.COMMENTS' | translate }}"
        [control]="$any(form.controls.comment)"
        [type]="'textarea'"
      ></app-impaired-input>
    </div>
    <div [class.impaired]="isImpaired" class="info" [class.show-detailed]="isDetailedShow">
      <app-catalog-item-card-info
        [ngClass]="{'mt24': isImpaired}"
        [showAllFields]="false"
        [isImpaired]="isImpaired"
        [showImpairedTitle]="isImpaired"
        [itemFields]="fields"
        [itemData]="selectCatalogItems"
        [showFloatTitle]="!isImpaired"
        borderRadius="20px"
        (close)="isDetailedShow = false"
        class="incorrect-data"
      ></app-catalog-item-card-info>
    </div>
    <app-form-array-group
      [isImpaired]="isImpaired"
      *ngIf="form.get('themeId')?.value === 1491"
      class="column-all"
      [selectOptions]="itemFields"
      [groupData]="attributeGroupData"
      [showEmptyOption]="false"
    ></app-form-array-group>
  </ng-container>
</form>
